// Constantes y ayudantes del control de documentos (Calidad, Fase 2).
//
// ARCHIVO SIN JSX A PROPÓSITO. El lint de la casa exige que un archivo
// que exporta componentes NO exporte además constantes: si lo hace, la
// recarga en caliente deja de funcionar y quien esté maquetando pierde
// el estado de la pantalla a cada guardado. Separarlos es más barato que
// convivir con eso.
export const TIPOS_DOCUMENTO = [
  ['PROCEDIMIENTO', 'Procedimiento'],
  ['INSTRUCCION', 'Instrucción de trabajo'],
  ['PLAN_CONTROL', 'Plan de control'],
  ['AMEF', 'AMEF'],
  ['HOJA_PROCESO', 'Hoja de proceso'],
  ['FORMATO', 'Formato'],
  ['EXTERNO', 'Documento externo'],
];

// EL ESTADO SE DICE CON PALABRAS Y CON COLOR, no solo con color: quien no
// distingue verde de ámbar tiene que poder leerlo (Doctrina 2, regla 2).
export const PALABRA_REVISION = {
  VIGENTE: 'Vigente',
  BORRADOR: 'Borrador · todavía no la ve nadie',
  OBSOLETA: 'Obsoleta · no usar',
};

export const TONO_REVISION = {
  VIGENTE: 'bg-green-50 text-green-800 border-green-200',
  BORRADOR: 'bg-amber-50 text-amber-800 border-amber-200',
  OBSOLETA: 'bg-gray-100 text-gray-600 border-gray-200',
};

export function fechaCorta(v) {
  if (!v) return null;
  // Mediodía a propósito: con la fecha a las 00:00 UTC, un huso al oeste
  // la enseñaría como el día anterior.
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit', month: 'short', year: 'numeric',
  }).format(new Date(`${v}T12:00:00`));
}
